import styled from 'styled-components';

export const CardContainer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    max-width: 400px;
    flex-direction: column;
    justify-content: center;
    box-shadow: -4px 4px 4px 0px rgba(10, 20, 26, 0.30);
    border-radius: 16px;
    overflow: hidden;
    transition: transform 0.2s ease;

    &:hover {
        transform: translateY(-4px);
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
        opacity: 0.7;
    }
`;

export const UpperSection = styled.div`
    position: relative;
    display: flex;
    padding: 12px;
    justify-content: left;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    z-index: 1;
    background: ${({ theme }) => theme?.colors?.theme?.contentBg};
`;

export const CollectionImage = styled.img`
    width: 96px;
    height: 96px;
    border-radius: 8px;
    object-fit: cover;
`;

export const CollectionInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const CollectionName = styled.h3`
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-family: 'Red Hat Display', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 120%;
    margin: 0;
`;

export const CollectionCount = styled.span`
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    font-family: 'Red Hat Display', sans-serif;
    font-size: 14px;
    font-weight: 400;
`;

export const LowerSection = styled.div`
    position: relative;
    display: flex;
    padding: 12px;
    align-items: left;
    gap: 16px;
    align-self: stretch;
    box-shadow: 0px 5px 32px 0px rgba(0, 67, 101, 0.08);
`;

export const CollectiblePreview = styled.div`
    width: 100%;
    max-width: 64px;
    height: 100%;
    max-height: 64px;
    border-radius: 8px;
    overflow: hidden;
`;

export const CollectibleImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const MoreCollectibles = styled.div`
    width: 100%;
    max-width: 64px;
    height: 100%;
    max-height: 64px;
    border-radius: 8px;
    background: rgba(23, 36, 43, 0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme?.colors?.common?.white};
    font-family: 'Red Hat Display', sans-serif;
    font-size: 12px;
    font-weight: 700;
`; 